import { TStore } from '@components/types';
import { getSafeUrl } from '@core/utils';

const ORIGIN = 'https://jhattse.com';

const storeNode = (store: TStore, kind: 'stay' | 'store') => {
    const minPrice = (store as any).min_price;
    const maxPrice = (store as any).max_price;
    const address = store.address;
    const hasRating = store.stats?.rating_count > 0;
    return {
        '@type': kind === 'stay' ? 'Hotel' : 'LocalBusiness',
        name: store.name,
        url: `${ORIGIN}/${kind === 'stay' ? 'stays' : 'store'}/${store.id}/${getSafeUrl(store.name)}`,
        image: store.image || store.logo || undefined,
        telephone: store.phone || undefined,
        priceRange: minPrice > 0 ? (maxPrice > minPrice ? `₹${minPrice}–₹${maxPrice}` : `₹${minPrice}`) : undefined,
        address: address ? {
            '@type': 'PostalAddress',
            streetAddress: [address.street_name, address.locality].filter(Boolean).join(', ') || undefined,
            addressLocality: address.city?.name || undefined,
            addressRegion: address.state?.name || undefined,
            postalCode: address.pincode || undefined,
            addressCountry: 'IN',
        } : undefined,
        aggregateRating: hasRating ? {
            '@type': 'AggregateRating',
            ratingValue: store.stats.rating_overall,
            bestRating: 5,
            reviewCount: store.stats.rating_count,
        } : undefined,
    };
};

type StoreGroup = { stores: TStore[] | undefined; kind: 'stay' | 'store' };

// One ItemList for a listing page (Google allows a single list per page, so every group
// goes into it with continuous positions). Entries without an id or name are skipped;
// returns null when nothing is left so callers can skip the <script> entirely.
export const storeListJsonLd = (name: string, groups: StoreGroup[], withContext = true) => {
    const items = groups.flatMap(({ stores, kind }) =>
        (stores || []).filter((s) => s?.id > 0 && s.name).map((store) => storeNode(store, kind)));
    if (!items.length) return null;
    return {
        ...(withContext ? { '@context': 'https://schema.org' } : {}),
        '@type': 'ItemList',
        name,
        numberOfItems: items.length,
        itemListElement: items.map((item, i) => ({ '@type': 'ListItem', position: i + 1, item })),
    };
};
